import {isNil} from 'ramda';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {currencyFormatter} from '../../util/Utils';

const Wrapper = styled.div`
    margin: 10px 0;
    position: relative;
    display: flex;
    flex-direction: column
    padding: 17px 21px;
    border-radius: 15px;
    background-color: #FFFFFF;
    box-shadow: 0 4px 0 0 rgba(0,0,0,0.2);
`;

const CardHeader = styled.div``;

const Message = styled.p`
  color: #666666;
  font-family: Roboto;
  font-size: 14px;
  letter-spacing: 0.87px;
  line-height: 20px;
  margin: 10px 0 30px;
`;

const ActivityTotal = styled.p`
  font-family: Roboto, arial, san serif;
  font-size: 54px !important;
  color: #777777 !important;
  line-height: 54px !important;
  &::first-letter {
    font-size: 20px;
    float: none;
    vertical-align: super;
  }
`;

const Title = styled.h3`
  margin: 0;
`;

const TopRightMetadata = styled.h5`
  position: absolute;
  top: 0;
  right: 0;
  padding: 20px;
  
  color: #666666;
  font-family: Roboto;
  font-size: 14px;
  letter-spacing: 0.87px;
`;

const Card = ({children, title, activityTotal, emptyMessage, maxMessage, activityMax}) => {
  const isShowEmptyMessage = isNil(activityTotal) || activityTotal === 0;
  const isShowMaxMessage = !isShowEmptyMessage && activityTotal === activityMax;
  const maxAmountText = `$${activityMax} max`;
  return (
    <Wrapper>
      <CardHeader>
        <Title>{title}</Title>
        <TopRightMetadata>
          <i>({maxAmountText})</i>
        </TopRightMetadata>
        <ActivityTotal>{currencyFormatter.format(activityTotal)}</ActivityTotal>
      </CardHeader>
      {isShowEmptyMessage && <Message>{emptyMessage}</Message>}
      {isShowMaxMessage && <Message>{maxMessage}</Message>}
      {children}
    </Wrapper>
  );
};

Card.propTypes = {
  children: PropTypes.any,
  title: PropTypes.string.isRequired,
  activityTotal: PropTypes.number.isRequired,
  emptyMessage: PropTypes.string.isRequired,
  maxMessage: PropTypes.string,
  activityMax: PropTypes.number.isRequired
};
Card.defaultProps = {
  maxMessage: 'All money earned, nice!'
};

export default Card;



// WEBPACK FOOTER //
// ./src/components/Card/Card.js